export default __webpack_public_path__ + "static/SRUS CS5 - Especification Del Producto y Datos Técnicos-2d005ad8d8bdec0fc592ab3fbfafe512.pdf";